import React from "react";

export function ServiceCard({ title, description, icon, link }) {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="service-card-link">
      <div className="service-card p-4 mt-8 rounded-lg shadow-lg text-center">
        {/* Icon */}
        <div className="icon-container mb-3">{icon}</div>
        {/* Title */}
        <h4 className="text-lg font-semibold mb-2">{title}</h4>
        {/* Description */}
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </a>
  );
}
